// Array of field configurations

export const breadcrumbItems = [{ label: "Banners", link: "/auth/banners" }];
